import ChangeKeywordsExclusions from 'components/Dashboard/utilities/changeKeywordExclusions';
import ChangeKeywordsCategory from 'components/Dashboard/utilities/changeKeywordsCategory';
import ChangeSearchQuery from 'components/Dashboard/utilities/changeSearchQuery';

const useAnalyticsApiHelpers = () => {
  const addCommonAnalyticsProperties = (baseProps, { topic, freeSearch, teamId, stakeholderId, tweets }) => {
    let requestProperties = { ...baseProps };
    if (topic?.prospective) {
      const { keywords, andKeywords, keywordExclusions } = topic;
      requestProperties = {
        ...requestProperties,
        query: ChangeKeywordsCategory(keywords),
        andQueries: ChangeKeywordsExclusions(andKeywords),
        mustNotQueries: ChangeKeywordsExclusions(keywordExclusions),
      };
    } else if (freeSearch) {
      requestProperties = {
        ...requestProperties,
        query: ChangeSearchQuery(freeSearch),
      };
    } else if (topic?.id) {
      requestProperties = {
        ...requestProperties,
        keywordListId: topic.id,
      };
    }
    if (stakeholderId) {
      requestProperties = {
        ...requestProperties,
        filters: [
          ...(requestProperties.filters || []),
          { field: tweets ? 'contactId' : 'contactIds', value: stakeholderId, operator: 'str_eq' },
        ],
      };
    }
    if (teamId) {
      requestProperties = {
        ...requestProperties,
        teamId,
      };
    }
    return requestProperties;
  };

  const createAnalyticsPathname = ({ teamId, freeSearch, conditionOfPublicApi, topic }) => {
    return `/api/${teamId ? 'widget' : 'graph-data'}/${
      freeSearch && conditionOfPublicApi ? 'public-' : ''
    }date-histogram${!!topic && !topic?.prospective && !freeSearch ? '-by-keyword-list' : ''}`;
  };

  return { addCommonAnalyticsProperties, createAnalyticsPathname };
};

export default useAnalyticsApiHelpers;
